module.exports = __webpack_public_path__ + "static/img/reference pics_USA pool.d02e6889.jpg";